import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import TrialOutreachHistoryRow from './TrialOutreachHistoryRow';
import CompanyOutreachOutcomeDialog from '../../companies/components/CompanyOutreachOutcomeDialog';

const HEADERS = ['Quando', 'Empresa', 'Público', 'Canal', 'Resultado', ''];
const COL_SPAN = HEADERS.length;

const headerCellSx = { fontWeight: 600, color: 'text.secondary', fontSize: '0.8125rem', whiteSpace: 'nowrap' };

/**
 * TrialOutreachHistoryTable - Histórico do contato com testes (Admin Geral)
 * @param {Object} props
 * @param {Array} props.items
 * @param {boolean} props.isLoading
 * @param {string|null} props.error
 * @param {Function} props.onOutcomeSaved (companyId, outcome|null)
 */
function TrialOutreachHistoryTable({ items, isLoading, error, onOutcomeSaved }) {
  const [editing, setEditing] = useState(null);

  return (
    <>
    <Paper
      sx={{
        borderRadius: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        border: '1px solid #E8ECF0',
        overflow: 'hidden',
      }}
    >
      {error && (
        <Alert severity="error" sx={{ borderRadius: 0 }}>
          {error}
        </Alert>
      )}

      <TableContainer sx={{ boxShadow: 'none', borderRadius: 0, overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#F8F9FC' }}>
              {HEADERS.map((label, index) => (
                <TableCell key={label || `col-${index}`} sx={headerCellSx}>{label}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={COL_SPAN} align="center" sx={{ py: 6 }}>
                  <CircularProgress size={32} />
                </TableCell>
              </TableRow>
            ) : items.length === 0 ? (
              <TableRow>
                <TableCell colSpan={COL_SPAN} align="center" sx={{ py: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    Nenhuma mensagem enviada ainda
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              items.map((item) => (
                <TrialOutreachHistoryRow key={item.id} item={item} colSpan={COL_SPAN} onMarkOutcome={setEditing} />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>

    <CompanyOutreachOutcomeDialog
      isOpen={!!editing}
      company={editing ? { id: editing.company_id, name: editing.company_name } : null}
      current={editing?.outcome || null}
      onSaved={(saved) => {
        onOutcomeSaved(editing.company_id, saved);
        setEditing(null);
      }}
      onCancel={() => setEditing(null)}
    />
    </>
  );
}

export default TrialOutreachHistoryTable;
